module.exports = __webpack_public_path__ + "img/img_erweima.077f81e6.png";